import React, { useState } from 'react';
import { LoanTable } from './components/LoanTable';
import { SummaryTiles } from './components/SummaryTiles';
import { initialLoanData } from './data/loanData';
import { LoanData } from './types/loan';
export function App() {
  const [loans, setLoans] = useState<LoanData[]>(initialLoanData);
  const handleUpdateLoan = (updatedLoan: LoanData) => {
    setLoans(prev => prev.map(loan => loan.id === updatedLoan.id ? updatedLoan : loan));
  };
  return <div className="min-h-screen w-full p-6 md:p-10 font-sans bg-[#f0f2f5]" data-id="element-0">
      <div className="max-w-[100vw] mx-auto" data-id="element-1">
        <div className="mb-6" data-id="element-2">
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight" data-id="element-3">
            Loan Pipeline
          </h1>
          <p className="text-slate-400 text-sm mt-1.5" data-id="element-4">
            Tracking {loans.length} active loans across all stages
          </p>
        </div>
        <SummaryTiles loans={loans} data-id="element-5" />
        <LoanTable loans={loans} onUpdateLoan={handleUpdateLoan} data-id="element-6" />
      </div>
    </div>;
}